import React, { Component } from 'react';
import ReactJSPopup from 'reactjs-popup';

import { WarningData } from 'client/bundles/types';
import Button from 'client/components/lego/button';

import 'client/components/popup/index.css';
import 'client/components/text/index.css';
import 'client/components/visually-hidden/index.css';
import cn from 'client/utils/cn';

import './index.css';

const b = cn('warning-popup');

interface Props {
    data: WarningData;
}

interface State {
    isPopupOpen: boolean;
}

const WARNING_STORAGE_FLAG = 'not-show-warning-invest';

export default class WarningPopup extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isPopupOpen: false
        };
    }

    componentDidMount() {
        const notShowPopup = Boolean(localStorage.getItem(WARNING_STORAGE_FLAG));

        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ isPopupOpen: this.props.data.isShow && !notShowPopup });
    }

    closePopup = (): void => {
        localStorage.setItem(WARNING_STORAGE_FLAG, '1');

        document.body.style.removeProperty('overflow');
        this.setState({ isPopupOpen: false });
    }

    render(): React.ReactNode {
        const { data } = this.props;
        const { isPopupOpen } = this.state;

        if (!isPopupOpen) {
            return null;
        }

        return (
            <div className={b()}>
                <ReactJSPopup
                    open={isPopupOpen}
                    position="center center"
                    modal
                    lockScroll
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                    className={isPopupOpen ? 'opened-popup' : ''}
                    onClose={this.closePopup}
                    >
                    <div className="popup-modal">
                        <div className="popup-content__inner">
                            <button
                                className="popup-modal__close"
                                type="button"
                                onClick={this.closePopup}
                                >
                                <div className="visually-hidden">
                                    Закрыть
                                </div>
                            </button>

                            <div className={b('content')}>
                                <div className="text">
                                    <h2>{data.title}</h2>

                                    <div
                                        dangerouslySetInnerHTML={{ __html: data.text }}
                                        />
                                </div>

                                <div className={b('button')}>
                                    <Button
                                        className={b('approve-button')}
                                        theme="raised"
                                        size="m"
                                        onClick={this.closePopup}
                                        >
                                        {data.button}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ReactJSPopup>
            </div>
        );
    }
}
